import { render, staticRenderFns } from "./EventTile.vue?vue&type=template&id=bf4a1b10&scoped=true"
import script from "./EventTile.vue?vue&type=script&lang=js"
export * from "./EventTile.vue?vue&type=script&lang=js"
import style0 from "./EventTile.vue?vue&type=style&index=0&id=bf4a1b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a1b10",
  null
  
)

export default component.exports